module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/osago@2x-339b06a40af5c41c1d7b1fae72bf0a8a.png";